import { Component, Input, OnChanges } from "@angular/core";
import { Issue } from "@/_models/issue.interface";
import { Promotion } from "@/_models/promotion.interface";
import { Task } from "@/_models/task.interface";
import { SharedComponentsModule } from "../../shared-components.module";
import {
    AssignedItemMeta,
    AssignedItemMetaService,
    EMPTY_ASSIGNED_ITEM_META,
} from "@/_services/assigned-item-meta.service";
import { listItemTitle } from "@/_utility/list-item-title.util";
import { RECORD_TYPE_BADGES } from "@/_utility/record-type-badge.util";
import { AssignedItemMetaComponent } from "@/components/home/assigned-item-meta/assigned-item-meta.component";
import { TagModule } from "primeng/tag";

export type CombinedTaskCardType = "issue" | "promotion" | "task";

@Component({
    selector: "app-combined-task-card-mobile",
    standalone: true,
    imports: [SharedComponentsModule, TagModule, AssignedItemMetaComponent],
    templateUrl: "./combined-task-card-mobile.component.html",
    styleUrls: ["./combined-task-card-mobile.component.scss"],
})
export class CombinedTaskCardMobileComponent implements OnChanges {
    @Input() data!: Issue | Promotion | Task;
    @Input() type: CombinedTaskCardType;
    @Input() showEdit = false;
    @Input() asListRow: boolean = false;

    title: string = "";
    badgeStyleClass: string = "";
    badgeLabel: string = "";
    meta: AssignedItemMeta = EMPTY_ASSIGNED_ITEM_META;

    constructor(private metaService: AssignedItemMetaService) {}

    ngOnChanges(): void {
        const badge = RECORD_TYPE_BADGES[this.type];
        this.title = listItemTitle(this.data, badge.untitledTitle);
        this.badgeStyleClass = badge.styleClass;
        this.badgeLabel = badge.label;
        this.meta = this.metaFor(this.type);
    }

    private metaFor(type: CombinedTaskCardType): AssignedItemMeta {
        switch (type) {
            case "issue":
                return this.metaService.forCase(this.data as Issue);
            case "task":
                return this.metaService.forTask(this.data as Task);
            case "promotion":
                return this.metaService.forPromotion(this.data as Promotion);
        }
    }
}
